import { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import infoIcon from '../../constants/icons/info_icon.png';
import arrowUpIcon from '../../constants/icons/arrow_up_icon.png';
import arrowDownIcon from '../../constants/icons/arrow_down_icon.png';

const HomepageInfoCard = () => {
  const [isOpen, setIsOpen] = useState(false);

  // motion
  const info = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delay: 2.6,
        duration: 1
      }
    }
  };
  return (
    <motion.div
      key="homepageInfoCardWrapper"
      variants={info}
      initial="hidden"
      animate="visible"
      className="homepageInfoCardWrapper"
    >
      <div className="cardTitle">
        <img src={infoIcon} alt="infoIcon" className="gameInfoIcon" />
        About
      </div>
      <AnimatePresence key="homepageInfoButton" exitBeforeEnter>
        {!isOpen ? (
          <motion.button
            key="arrowDownButton"
            type="button"
            onClick={() => setIsOpen(!isOpen)}
            className="gameInfoButton"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1.2 }}
          >
            <img
              src={arrowDownIcon}
              alt="arrowDownIcon"
              className="gameInfoCollapseIcon"
            />
          </motion.button>
        ) : (
          <motion.button
            key="arrowUpButton"
            type="button"
            onClick={() => setIsOpen(!isOpen)}
            className="gameInfoButton"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1.2 }}
          >
            <img
              src={arrowUpIcon}
              alt="arrowUpIcon"
              className="gameInfoCollapseIcon"
            />
          </motion.button>
        )}
      </AnimatePresence>
      <motion.div
        key="homepageInfoCard"
        initial="collapsed"
        animate={isOpen ? 'open' : 'collapsed'}
        exit="collapsed"
        variants={{
          open: {
            height: '460px',
            transition: {
              delayChildren: 0.6,
              staggerChildren: 0.6,
              duration: 1.2,
              ease: 'easeInOut'
            }
          },
          collapsed: {
            height: '0px'
          }
        }}
        transition={{ duration: 1.2, ease: 'easeInOut' }}
      >
        {isOpen && (
          <>
            <motion.div
              key="homepageAbout-1"
              variants={{
                open: {
                  opacity: 1
                },
                collapsed: { opacity: 0 }
              }}
              className="homepageInfoCardContainer"
            >
              <h4>Bitcolympics DAPP</h4>
              <p>
                Bitcolympics is a decentralized app that hosts a collection of
                smart contract games.
              </p>
            </motion.div>
            <motion.div
              key="homepageAbout-2"
              variants={{
                open: {
                  opacity: 1
                },
                collapsed: { opacity: 0 }
              }}
              className="homepageInfoCardContainer"
            >
              <h4>Smart Contract Games</h4>
              <p>
                All games are built on the Binance blockchain and run on smart
                contracts.
              </p>
            </motion.div>
            <motion.div
              key="homepageAbout-3"
              variants={{
                open: {
                  opacity: 1
                },
                collapsed: { opacity: 0 }
              }}
              className="homepageInfoCardContainer"
            >
              <h4>User Privacy</h4>
              <p>
                Bitcolympics does not store or collect any user information, it
                is only for contract interaction.
              </p>
            </motion.div>
            <motion.div
              key="homepageAbout-4"
              variants={{
                open: {
                  opacity: 1
                },
                collapsed: { opacity: 0 }
              }}
              className="homepageInfoCardContainer"
            >
              <h4>Complete Data Integrity</h4>
              <p>
                The data stored on the blockchain is immutable and indisputable,
                thus there are no data breaches.
              </p>
            </motion.div>
          </>
        )}
      </motion.div>
    </motion.div>
  );
};

export default HomepageInfoCard;
